import React, { Component } from 'react';
import {  
  Button,
} from 'react-bootstrap';
// models 
import User from '../../models/User';
// stores 
import UserStore from '../../stores/UserStore';
// components
import UserInfoDialog from '../../components/User/UserInfoDialog';
// css
import './Buttons.css';

class AddPropertyButton extends Component {
  constructor(props) {
    super(props);
    this.state = { showDialog: false };
  }

  render() {
    return (
      <Button bsStyle="link" onClick={() => this.showDialog(true)}>
        Edit
        <UserInfoDialog
          show={this.state.showDialog}
          user={new User(UserStore.user.get())}
          onSave={this.onSave}
          onCancel={() => this.showDialog(false)} />
      </Button>
    );
  }

  showDialog = (bShow = false) => {
    this.setState({ showDialog: bShow });
  }

  onSave = (user) => {
    if (user) {
      UserStore.update(user);
      this.showDialog(false);
    }
  }
}

export default AddPropertyButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/EditUserInfo.js